import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import SubMenu from "../components/SubMenu";
import Loader from "../components/Loader";
import { Modal } from "react-bootstrap";
import SelectablePopUpOptions from "../components/SelectablePopUpOptions";
import CustomSelect from "../components/SelectableCustom";
import CustomSelectArray from "../components/CustomSelectArray";
import OpenClosedExceptions from "../components/OpenClosedExceptions";
import EstimatedTimePage from "../components/EstimatedTimeCustomersSpend";
import Separator from "../components/Separator";
import { Row, Col } from "react-bootstrap";
import { fetchRestaurantOpenDays, patchRestaurantOpenDays, createRestaurantOpenDays, fetchEstimatedTimeCustomersSpend, patchEstimatedTimeCustomersSpend, createEstimatedTimeCustomersSpend, fetchOpenClosedExceptions, patchOpenClosedExceptions, createOpenClosedExceptions, fetchHoursEach } from "../actions/restaurantActions";
import { api } from "../App";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faChair, faGear, faCircleXmark, faHourglassStart, faHourglassEnd, faFilePen } from "@fortawesome/free-solid-svg-icons";
import DropDownButton from "../components/DropDownButton";
import { XSvgIcon } from "../icons/SvgIcons";
import { ContainerBox, Header, CardHeader, CardHeaderTitle, Body, OrangeButton, Title } from "../components/DefaultImports";
const OpenDayCard = styled.div`
  border: 1px solid #e5e0d7;
  border-radius: 14px;
  padding: 18px;
  padding-right: 74px;
  margin-bottom: 12px;
  background-color: white;
  position: relative;
  box-shadow: 0 3px 12px rgba(75, 51, 53, 0.05);
`;
const WeekdaysContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
  margin-right: 0;
`;
const Weekday = styled.div`
  border: 1px solid ${props => props.isOpen ? "#ee754c" : "#d8d4cd"};
  border-radius: 999px;
  padding: 4px 9px;
  font-size: 12px;
  background-color: ${props => props.isOpen ? "#ee754c" : "transparent"};
  color: ${props => props.isOpen ? "white" : "#4b3335"};
`;
const Button = styled.button`
  display: inline-block;
  font-weight: 400;
  color: #fff;
  text-align: center;
  cursor: pointer;
  background-color: #75726f;
  border: 1px solid #75726f;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 9px;
  transition: background-color 0.2s, border-color 0.2s;
  &:hover {
    background-color: #474645;
    border-color: #474645;
  }
`;
const DangerButton = styled(Button)`
  background-color: #ff704d;
  border-color: #ff704d;
  &:hover {
    background-color: #ff471a;
    border-color: #ff471a;
  }
`;
const ActionButtons = styled.div`
  position: absolute;
  top: 14px;
  right: 14px;
  display: flex;
  gap: 4px;
`;
const ActionButton = styled.button`
  width: 34px;
  height: 34px;
  background: #faf6e9;
  border: 1px solid #e5e0d7;
  border-radius: 9px;
  color: #75726f;
  font-size: 17px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  &:hover {
    color: #ee754c;
    border-color: #ee754c;
  }
`;
function RestaurantTimeManagement({
  restaurant_ids = false,
  handleNextSteps = false,
  currentStep = false
}) {
  const {
    t
  } = useTranslation();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [timeStart, setTimeStart] = useState("12:00");
  const [timeEnd, setTimeEnd] = useState("22:00");
  const [shift, setShift] = useState("Dinner");
  const [selectedItems, setSelectedItems] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [openShift_id, setOpenShift_id] = useState("");
  const [update_delete, setUpdate_delete] = useState("");
  const [selectedOpenDay, setSelectedOpenDay] = useState(false);
  const [openDaysData, setOpenDaysData] = useState({});
  const dispatch = useDispatch();
  const [restaurant_id, setRestaurant_id] = useState(false);
  const openDayss = useSelector(state => state.restaurantOpenDaysOfTheWeek);
  const {
    openDays,
    isLoadingOpenDays
  } = openDayss;
  const hoursEachTime = useSelector(state => state.hoursEachTime);
  const {
    hoursEach
  } = hoursEachTime;
  const restaurantDetails = useSelector(state => state.restaurantDetails);
  const {
    restaurants,
    isLoading,
    error
  } = restaurantDetails;
  useEffect(() => {
    if (restaurants) {
      setRestaurant_id(restaurants.id);
    }
  }, [restaurants]);
  useEffect(() => {
    const processWeekdays = () => {
      const weekdaysMap = {
        Segunda: "Monday",
        Terça: "Tuesday",
        Quarta: "Wednesday",
        Quinta: "Thursday",
        Sexta: "Friday",
        Sábado: "Saturday",
        Domingo: "Sunday"
      };
      const days = Object.keys(weekdaysMap).reduce((acc, day) => {
        acc[weekdaysMap[day]] = selectedItems.includes(day);
        return acc;
      }, {});
      setOpenDaysData(days);
    };
    processWeekdays();
  }, [selectedItems]);
  const handleFormSubmit = e => {
    e.preventDefault();
    const openDaysDataToSubmit = {
      restaurant: restaurant_id,
      shift: shift,
      start_time: timeStart,
      end_time: timeEnd,
      ...openDaysData
    };
    if (update_delete === "update") {
      dispatch(patchRestaurantOpenDays(restaurant_id, openShift_id, openDaysDataToSubmit));
    } else {
      dispatch(createRestaurantOpenDays(restaurant_id, openDaysDataToSubmit));
    }
    setModalIsOpen(false);
  };
  const handleOpenTimeModal = (type, shift_id = "") => {
    setUpdate_delete(type);
    if (type === "update") {
      setOpenShift_id(shift_id);
      const openDay = openDays.find(day => day.id === shift_id);
      if (openDay) {
        setShift(openDay.shift);
        setTimeStart(openDay.start_time.slice(0, 5));
        setTimeEnd(openDay.end_time.slice(0, 5));
        const selected = [];
        if (openDay.Monday) selected.push("Segunda");
        if (openDay.Tuesday) selected.push("Terça");
        if (openDay.Wednesday) selected.push("Quarta");
        if (openDay.Thursday) selected.push("Quinta");
        if (openDay.Friday) selected.push("Sexta");
        if (openDay.Saturday) selected.push("Sábado");
        if (openDay.Sunday) selected.push("Domingo");
        setSelectedItems(selected);
      }
    }
    setModalIsOpen(true);
  };
  const handleShowModal = shift_id => {
    setShowModal(true);
    setOpenShift_id(shift_id);
  };
  const deleteOpenDay = async openDayId => {
    try {
      await api.delete(`restaurants/1/opentimes/${openDayId}/`);
    } catch (error) {
      console.error(error);
    }
    dispatch(fetchRestaurantOpenDays(restaurant_id));
    setShowModal(false);
    setModalIsOpen(false);
  };
  return <ContainerBox>
      <Header>
        <Title>{t("ui.screens.restaurantTimeManagement.turnosRegulares")}</Title>

        <OrangeButton onClick={() => handleOpenTimeModal("create")}>{t("ui.screens.restaurantTimeManagement.criarTurno")}<FontAwesomeIcon icon={faPlus} />
        </OrangeButton>
      </Header>
      <Body>
        {isLoadingOpenDays ? <Loader /> : openDays && openDays.length > 0 ? openDays.map(openDay => <OpenDayCard key={openDay.id}>
              <div>{t("ui.screens.restaurantTimeManagement.turnoRegular")}</div>
              <h5>{openDay.shift}</h5>
              <div>
                <FontAwesomeIcon icon={faHourglassStart} style={{
            color: "#ee754c",
            marginRight: "5px",
            fontSize: "20px"
          }} />{t("ui.screens.restaurantTimeManagement.inicio")}{openDay.start_time.slice(0, 5)}
                <FontAwesomeIcon icon={faHourglassEnd} style={{
            color: "#ee754c",
            marginLeft: "10px",
            marginRight: "5px",
            fontSize: "20px"
          }} />{t("ui.screens.restaurantTimeManagement.fim")}{openDay.end_time.slice(0, 5)}
              </div>

              <WeekdaysContainer>
                <Weekday isOpen={openDay.Monday}>{t("ui.screens.restaurantTimeManagement.segunda")}</Weekday>
                <Weekday isOpen={openDay.Tuesday}>{t("ui.screens.restaurantTimeManagement.terca")}</Weekday>
                <Weekday isOpen={openDay.Wednesday}>{t("ui.screens.restaurantTimeManagement.quarta")}</Weekday>
                <Weekday isOpen={openDay.Thursday}>{t("ui.screens.restaurantTimeManagement.quinta")}</Weekday>
                <Weekday isOpen={openDay.Friday}>{t("ui.screens.restaurantTimeManagement.sexta")}</Weekday>
                <Weekday isOpen={openDay.Saturday}>{t("ui.screens.restaurantTimeManagement.sabado")}</Weekday>
                <Weekday isOpen={openDay.Sunday}>{t("ui.screens.restaurantTimeManagement.domingo")}</Weekday>
              </WeekdaysContainer>

              <ActionButtons>
                <ActionButton
                  type="button"
                  onClick={() => handleOpenTimeModal("update", openDay.id)}
                  title={t("ui.screens.restaurantTimeManagement.editarTurno")}
                  aria-label={t("ui.screens.restaurantTimeManagement.editarTurno")}
                >
                  <FontAwesomeIcon icon={faFilePen} />
                </ActionButton>
                <ActionButton
                  type="button"
                  onClick={() => handleShowModal(openDay.id)}
                  title={t("ui.screens.restaurantTimeManagement.eliminarTurno")}
                  aria-label={t("ui.screens.restaurantTimeManagement.eliminarTurno")}
                >
                  <XSvgIcon width={20} height={20} strokeColor={"#99B0AD"} style={{
              marginLeft: "4px",
              marginRight: "4px"
            }} />
                </ActionButton>
              </ActionButtons>
            </OpenDayCard>) : <div>{t("ui.screens.restaurantTimeManagement.nadaParaVerAqui")}</div>}
      </Body>

      <Modal show={modalIsOpen} onHide={() => setModalIsOpen(false)}>
        <Modal.Header>
          {update_delete === "update" ? <h5>{t("ui.screens.restaurantTimeManagement.editarTurno")}</h5> : <h5>{t("ui.screens.restaurantTimeManagement.criarTurno2")}</h5>}
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleFormSubmit}>
            <Row>
              <Col xs={6}>
                <label htmlFor="start_time">{t("ui.screens.restaurantTimeManagement.horaDeInicioDoTurno")}</label>
                <DropDownButton options={hoursEach} handleOptionChange={setTimeStart} initialOption={timeStart} />
              </Col>
              <Col xs={6}>
                <label htmlFor="end_time">{t("ui.screens.restaurantTimeManagement.horaDeFimDoTurno")}</label>
                <DropDownButton options={hoursEach} handleOptionChange={setTimeEnd} initialOption={timeEnd} />
              </Col>
            </Row>
            <div>
              <label htmlFor="weekdays">{t("ui.screens.restaurantTimeManagement.diasDaSemana")}</label>
              <CustomSelectArray items={["Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado", "Domingo"]} onSelectChange={setSelectedItems} selectedItems={selectedItems} />
            </div>
            <Modal.Footer>
              <Button type="submit">{t("ui.screens.restaurantTimeManagement.gravar")}</Button>
              <Button type="button" onClick={() => setModalIsOpen(false)}>{t("ui.screens.restaurantTimeManagement.cancelar")}</Button>
            </Modal.Footer>
          </form>
        </Modal.Body>
      </Modal>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{t("ui.screens.restaurantTimeManagement.eliminarTurno")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("ui.screens.restaurantTimeManagement.temACertezaQueDesejaEliminar")}</Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowModal(false)}>{t("ui.screens.restaurantTimeManagement.cancelar2")}</Button>
          <DangerButton onClick={() => deleteOpenDay(openShift_id)}>{t("ui.screens.restaurantTimeManagement.eliminar")}</DangerButton>
        </Modal.Footer>
      </Modal>
    </ContainerBox>;
}
export default RestaurantTimeManagement;
